import { ImageWithFallback } from "./figma/ImageWithFallback";
import { Button } from "./ui/button";
import playtimeimg from './../styles/play_time.jpg';
import learningimg from './../styles/learning.jpg';
import gamesimg from './../styles/gallery_play_area.jpg';
import scienceimg from './../styles/outdoor.jpg';
import outdoorimg from './../styles/games_activity.jpg';
import artimg from './../styles/arts.jpg';

const galleryImages = [
  {
    src: playtimeimg,
    alt: "Children playing with educational toys",
    category: "Play Time"
  },
  {
    src: learningimg,
    alt: "Kids learning together in classroom",
    category: "Learning"
  },
  {
    src: gamesimg,
    alt: "Children playing educational games",
    category: "Games"
  },
  {
    src: scienceimg,
    alt: "Kids science experiment",
    category: "Science"
  },
  {
    src: outdoorimg,
    alt: "Kids outdoor play",
    category: "Outdoor"
  },
  {
    src: artimg,
    alt: "Children art creative",
    category: "Art"
  }
];

export function Gallery() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-medium">
            Our Gallery
          </span>
          <h2 className="text-4xl font-bold text-gray-800 mt-4 mb-6">
            Moments of Joy & Discovery
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a glimpse into our vibrant learning environment where children explore, 
            create, and grow together every day.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className={`relative group cursor-pointer overflow-hidden rounded-lg ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : 
                index === 3 ? 'lg:col-span-2' : ''
              }`}
            >
              <ImageWithFallback
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4">
                  <span className="bg-white/90 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">
                    {image.category}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full text-lg">
            View All Photos
          </Button>
        </div>
      </div>
    </section>
  );
}